/**
 * Created by fishelly on 2021/05/11.
 */

class IndexedDBUtil {
    constructor (config) {
        this.config = config;
    }

    open () {
        if (this.__isInited) {
            return Promise.resolve({type: 'init', instance: this.instance});
        }
        const {version, name} = this.config;
        return new Promise((resolve, reject) => {
            this.dbOpenRequest = window.indexedDB.open(name, version);
            this.dbOpenRequest.onerror = (event) => {
                reject({code: -1, errmessage: 'indexeddb打开失败'});
            };

            this.dbOpenRequest.onsuccess = (event) => {
                this.instance = this.dbOpenRequest.result;
                this.__isInited = true;
                resolve({type: 'init', instance: this.instance});
            };

            this.dbOpenRequest.onupgradeneeded = (event) => {
                let db = event.target.result;

                db.onerror = function (event) {
                    reject({code: -1, errmessage: 'indexeddb打开失败'});
                };
                this.instance = db;
                resolve({type: 'upgrade', instance: db});

            };
        });
    }

    add (item) {
        return new Promise((resolve, reject) => {
            if (!item) {
                reject({code: -1, errmessage: '添加的数据不能为空'});
                return;
            }
            var transaction = this.instance.transaction([this.config.name], 'readwrite');
            var objectStore = transaction.objectStore(this.config.name);
            var objectStoreRequest = objectStore.add(item);
            objectStoreRequest.onsuccess = (event) => {
                resolve();
            };
            objectStoreRequest.onerror = (e) => {
                reject(e);
            };
        });
    }

    get (key, withStore) {
        return new Promise((resolve, reject) => {
            if (!key){
                reject({code: -1, errmessage: '键值不能为空'});
                return;
            }
            var transaction = this.instance.transaction([this.config.name], 'readwrite');
            // 打开已经存储的数据对象
            var objectStore = transaction.objectStore(this.config.name);
            // 获取存储的对应键的存储对象
            var objectStoreRequest = objectStore.get(key);
            // 获取成功后替换当前数据
            objectStoreRequest.onsuccess = (event) => {
                // 当前数据
                var myRecord = objectStoreRequest.result;

                if (myRecord && withStore) {
                    myRecord._store = objectStore;
                }
                resolve(myRecord);
            };
            objectStoreRequest.onerror = (e) => {
                reject(e);
            };
        });
    }

    addOrEdit (item, indexKey) {
        if (!item || !indexKey) {
            return Promise.reject({code: -1, errmessage: '不能为空'});
        }
        return new Promise((resolve, reject) => {
            this.get(item[indexKey], 'readwrite').then(myRecord => {
                if (!myRecord) {
                    this.add(item).then(e => resolve(e)).catch(e => reject(e));
                    return;
                }
                const objectStore = myRecord._store;
                delete myRecord._store;

                Object.assign(myRecord, item);
                // 更新数据库存储数据

                objectStore.put(myRecord);
                resolve(myRecord);
            }).catch((e) => {
                reject(e);
            });
        });
    }

    edit (key, item) {
        return new Promise((resolve, reject) => {
            this.get(key, 'readwrite').then(myRecord => {
                const objectStore = myRecord._store;
                delete myRecord._store;

                Object.assign(myRecord, item);
                // 更新数据库存储数据

                objectStore.put(myRecord);
                resolve(myRecord);
            }).catch((e) => {
                reject(e);
            });
        });

    }

    delete (key) {
        // 打开已经存储的数据对象
        var objectStore = this.instance.transaction([this.config.name], 'readwrite').objectStore(this.config.name);
        // 直接删除
        var objectStoreRequest = objectStore.delete(key);

        return new Promise((resolve, reject) => {
            // 删除成功后
            objectStoreRequest.onsuccess = function () {
                resolve();
            };
            objectStoreRequest.onerror = (e) => {
                reject(e);
            };
        });

    }

    getList (key) {

        // 打开对象存储，获得游标列表
        var objectStore = this.db.transaction(dbName).objectStore(dbName);
        var list = [];
        return new Promise((resolve, reject) => {
            objectStore.openCursor().onsuccess = function (event) {
                var cursor = event.target.result;
                // 如果游标没有遍历完，继续下面的逻辑
                if (cursor) {
                    list.push(cursor.value);
                } else {
                    resolve(list);
                }
            };
        });

    }

}

export default function (injection, Vue) {

    Object.defineProperties(Vue.prototype, {
        $indexedDb: {
            get () {
                return factory;
            }
        }
    });

    Object.defineProperties(injection, {
        indexedDb: {
            get () {
                return factory;
            }
        }
    });
    const map = {};
    const factory = function (config) {
        const key = `${config.name}_${config.version}`;
        let instance = map[key];
        if (instance) {
            return instance;
        }
        map[key] = new IndexedDBUtil(config);
        return map[key].open();
    };
}
